import Api from "../common/api";
import { HttpResponse } from "../common/response-model";
import { Url } from "../common/url";

export class ProfileService {
  private static instance: ProfileService;
  private constructor() {}

  public static getInstance(): ProfileService {
    if (!ProfileService.instance) {
      ProfileService.instance = new ProfileService();
    }
    return ProfileService.instance;
  }
  public getProfile = async (id: any): Promise<HttpResponse<any>> => {
    return await Api.get(`${Url.getProfile}`);
  };
  public editProfile = async (id: any, data: any): Promise<HttpResponse<any>> => {
    return await Api.put(`${Url.editProfile}`, data);
  };
  public patientList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.patientList, data);
  };
  public createPatient = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.createPatient, data);
  };
  public updatePatient = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.updatePatient, data);
  };
  public addFamilyMember = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.addFamilyMember, data);
  };
  public updateFamilyMember = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.updateFamilyMember, data);
  };
  public deleteMember = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.deleteFamilyMember, data);
  };
  public orderList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.orderList, data);
  };
  public addressList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.addressList, data);
  };
  public addAddress = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.addAddress, data);
  };
  public updateAddress = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.updateAddress, data);
  };
  public termCondition = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.termsCondition, data);
  };
  public reportList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.packages, data);
  };
  public paymentHistory = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.paymentHistory, data);
  };
  public userActivityLog = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.userActivityLog, data);
  };
  public profileMaster = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.getMasterArr);
  };
  public cityList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.getCityList, data);
  };
  public pincodeList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.getPincodeList, data);
  };
  public stateList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.get(Url.getStateList);
  };
  public cancelBooking = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.bookingCancel, data);
  };
  public refundBooking = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.refundBooking, data);
  };
  public bookingDetails = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.bookingDetails, data);
  };
  public cartList = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.cartlist, data);
  };
  public refundDetails = async (data: any): Promise<HttpResponse<any>> => {
    return await Api.post(Url.refundDetails, data);
  };
}
